var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"view-content-list"},[_vm._l((_vm.contentCollection.models),function(contentModel){return _c('ViewContentCard',{key:contentModel.id,attrs:{"contentModel":contentModel},on:{"select":_vm.Handle_OnSelectContent}})}),(_vm.contentCollection.length === 0)?_c('ViewUiStateLoader'):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }